export default __webpack_public_path__ + "static/rovo-actions-light-f187771616464eaca9750544c6489c16.png";